export default __webpack_public_path__ + "static/media/rent_a_car.89f0ae62.png";